import React from 'react'
import { getName } from '../../helpers/user.helper'
import logo from '../../assets/img/logo.png';

export default function AsideLeftMenuBills() {
    return (
        <>
            <aside className="main-sidebar sidebar-dark-primary elevation-4">
                <a href="/vendas" className="brand-link">
                    <img src={logo} alt="Hondix Logo" />
                </a>
                <div className="sidebar">
                    <div className="user-panel mt-3 pb-3 mb-3 d-flex">
                        <div className="image">
                            {/* <img src="dist/img/user2-160x160.jpg" className="img-circle elevation-2" alt="User Image" /> */}
                        </div>
                        <div className="info">
                            <a href="#" className="d-block">{getName()}</a>
                        </div>
                    </div>
                    <nav className="mt-2">
                        <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
                            <li className="nav-item">
                                <a href="/aplicativo" className={`nav-link `}>
                                    <i className="fa fa-money" />&nbsp;
                                    <p>Contas pendentes</p>
                                </a>
                            </li>
                            
                            <li className="nav-item">
                                <a href="/aplicativo" className={`nav-link `}>
                                    <i className="fa fa-money" />&nbsp;
                                    <p>Histórico de cobranças</p>
                                </a>
                            </li>
                        </ul>
                    </nav>

                    
                </div>
            </aside>
        </>
    )
}
